<script>
	import { browser } from '$app/environment';
	import ButtonBoxTextColor from '$lib/elements/buttons/variants/ButtonBoxTextColor.svelte';
	import { t } from 'svelte-i18n';
	import { logError } from '@app/utils/log';

	const showPrompt = async () => {
		// Show the prompt
		await window.deferredInstallPrompt?.prompt();
		// Wait for the user to respond to the prompt
		window.deferredInstallPrompt?.userChoice
			.then((choiceResult) => {
				if (choiceResult.outcome === 'accepted') {
					console.log('User accepted the A2HS prompt');
					window.deferredInstallPrompt = null;
				} else {
					console.log('User dismissed the A2HS prompt');
				}
			})
			.catch(reason => logError("unexpected error", reason));
	};
</script>

<svelte:head>
	<script>
		window.addEventListener('beforeinstallprompt', (event) => {
			event.preventDefault();
			window.deferredInstallPrompt = event;
		});

		window.addEventListener('appinstalled', () => {
			console.log('a2hs installed');
		});
	</script>
</svelte:head>

{#if browser && window?.deferredInstallPrompt}
	<ButtonBoxTextColor
		props={{ iconLeft: 'get_app', label: $t('header.installApp'), classNames: 'lg:hidden' }}
		on:click={() => showPrompt()}
	/>
	<ButtonBoxTextColor
		props={{
			roundedFull: true,
			iconLeft: 'get_app',
			tooltip: { title: $t('header.installApp') },
			classNames: 'hidden lg:block'
		}}
		on:click={() => showPrompt()}
	/>
{/if}
